const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PASSWORD_SECURE_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;

export function isValidEmail(email) {
  return EMAIL_REGEX.test(String(email || "").trim());
}

export function isSecurePassword(password) {
  return PASSWORD_SECURE_REGEX.test(String(password || ""));
}
